import type { AccountId } from '../../model/index.tsx';
import get from '../../rest/board/get/index.tsx';
import { transformUserAccountFromBoard } from './transformers.tsx';

const searchBoards = async (baseUrl: string, boardId: string): Promise<AccountId> => {
	const response = await get(baseUrl, boardId);

	return transformUserAccountFromBoard(baseUrl, response);
};

export default searchBoards;
